module.exports = __webpack_public_path__ + "static/media/pause.00c263c6.svg";